<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {Component} from "../types.ts";
import useStore from "../store.ts";
import {buildAssetUrl} from "../utils/AssetUrl.ts";
// Original artwork, no third-party license.
import placeholderUrl from "../assets/image-not-found.svg";

const props = defineProps<{
  item: Component
}>();

// Shown instead of a video that fails to load.
const showPlaceholder = ref(false);
const store = useStore();
// Reactive: the content base only exists once the authenticate reply lands.
const environment = computed(() => store.device_settings?.content_url ?? "");
const videoSrc = computed(() => buildAssetUrl(props.item.published?.src, environment.value));
// Quoted: the inlined SVG data URL contains ' and ( which an unquoted url() rejects.
const placeholderImage = `url("${placeholderUrl}")`;

// A new src is a fresh chance.
watch(videoSrc, () => {
  showPlaceholder.value = false;
});

const onError = () => {
  showPlaceholder.value = true;
}
</script>

<template>
  <div :id="`${item.props.id}`" :style="item.props.style"  >
    <video :src="videoSrc" @error="onError"  autoplay="true" v-show="!showPlaceholder"
         :style="{...item.props.style, top: 0, left: 0, display: 'block', maxHeight: '100%', maxWidth: '100%'}" />
    <div v-if="showPlaceholder" :style="{
           width: '100%',
           height: '100%',
           backgroundImage: placeholderImage,
           backgroundSize: 'contain',
           backgroundPosition: 'center',
           backgroundRepeat: 'no-repeat',
         }"></div>
    <slot>
    </slot>
  </div>

</template>

<style scoped>
video {
  pointer-events: none;
}
</style>
